<template>
  <div>
    <v-layout row>
      <v-tooltip
        bottom
        :disabled="selection.requestsCount <= 0"
      >
        <div slot="activator">
          <v-icon
            :disabled="selection.requestsCount > 0"
            :class="$vuetify.breakpoint.smAndDown ? 'pr-2' : 'pr-3'"
            class="pb-1"
            :style="{
              'margin-left': $vuetify.breakpoint.smAndDown ? '0px' : '12px',
              'font-size': $vuetify.breakpoint.smAndDown ? '1.4em' : '',
              'margin-top': $vuetify.breakpoint.smAndDown ? '25px' : '15px',
              'align-self': $vuetify.breakpoint.smAndDown ? 'start': ''
            }"
            style="cursor: pointer"
            :color="deleteHover ? 'red' : null"
            @mouseover="deleteHover = true"
            @mouseout="deleteHover = false"
            @click="$emit('deleteSelection');"
          >
            {{ selection.requestsCount > 0 ? 'delete_outline' : 'delete' }}
          </v-icon>
        </div>
        <span>{{ $t('editingContainer.unableToDeleteDish', { count: selection.requestsCount }) }}</span>
      </v-tooltip>
      <v-layout row wrap>
        <v-flex xs3 sm2 md1 class="pr-3">
          <v-layout row wrap>
            <v-flex xs6 class="pr-2">
              <v-text-field
                ref="price"
                v-model="selection.price"
                type="number"
                :label="priceTranslation"
                step="0.1"
                :rules="[rules.required,
                         rules.greaterThanZero,
                         rules.numberLessThan(100),
                         rules.priceNotGreaterThanInitialWhenOrdersExist(selection.requestsCount > 0, initialPrice)]"
                :name="categoryTranslation"
                required
              />
            </v-flex>
            <v-flex xs6>
              <v-text-field
                ref="maxCount"
                v-model="selection.maxCount"
                type="number"
                :label="countTranslation"
                step="1"
                :rules="[rules.greaterThanZero, rules.integer, rules.numberLessThan(1000)]"
                :name="categoryTranslation"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs9 sm5 md6 class="pr-3">
          <v-text-field
            ref="selectionName"
            v-model="selection.dishes[0].name"
            :label="selectionNameTranslation"
            required
            :rules="[rules.lengthNotGreaterThan,
                     !!selection.dishes[0].translation || !!selection.dishes[0].name || `'${selectionNameTranslation}' or '${translationTranslation}' field is required.`]"
            :name="categoryTranslation"
            @keyup.enter="onEnter"
          />
        </v-flex>
        <v-flex xs9 :sm3="!selection.dishes[0].translation" :sm5="!!selection.dishes[0].translation">
          <v-text-field
            ref="translation"
            v-model="selection.dishes[0].translation"
            :label="translationTranslation"
            :rules="[rules.lengthNotGreaterThan,
                     !!selection.dishes[0].translation || !!selection.dishes[0].name|| `'${selectionNameTranslation}' or '${translationTranslation}' field is required.`]"
            :name="categoryTranslation"
            @keyup.enter="onEnter"
          />
        </v-flex>
      </v-layout>
    </v-layout>
    <v-divider v-if="$vuetify.breakpoint.smAndDown" />
  </div>
</template>
<script>
import ValidationService from '@/services/ValidationService';

export default {
  name: 'SingleSelection',
  props: {
    selection: {
      type: Object,
      required: true,
    },
    categoryName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      deleteHover: false,
      initialPrice: this.selection.price,
      fieldsToValidate: [
        'price',
        'selectionName',
        'translation',
      ],
      rules: {
        required: ValidationService.rules.required(),
        integer: ValidationService.rules.integer(),
        greaterThanZero: ValidationService.rules.greaterThanZero(),
        numberLessThan: ValidationService.rules.numberLessThan(),
        priceNotGreaterThanInitialWhenOrdersExist: ValidationService.rules.priceNotGreaterThanInitialWhenOrdersExist(),
        lengthNotGreaterThan: ValidationService.rules.lengthNotGreaterThan('Value must not exceed 500 characters.', 500),
      },
    };
  },
  computed: {
    categoryTranslation() {
      return this.$t('editingContainer.category', { category: this.categoryName });
    },
    selectionNameTranslation() {
      return this.$t('editingContainer.selectionName');
    },
    priceTranslation() {
      return this.$t('common.price');
    },
    countTranslation() {
      return this.$t('common.count');
    },
    translationTranslation() {
      return this.$t('editingContainer.translation');
    },
  },
  methods: {
    validate() {
      return ValidationService.validate(Object.keys(this.$refs)
        .filter(k => this.fieldsToValidate.includes(k))
        .map(k => this.$refs[k]));
    },
    onEnter() {
      this.$emit('onEnter');
    },
    focus() {
      this.$refs.selectionName.focus();
    },
  },
};
</script>
